// extracted by mini-css-extract-plugin
export default {"inside":"task-info_inside__IhUZS"};